'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ToolbarIcon = require('./ToolbarIcon');

var _ToolbarIcon2 = _interopRequireDefault(_ToolbarIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BLOCK_TYPES = [{ label: 'H1', style: 'header-one' }, { label: 'H2', style: 'header-two' }, { icon: 'a-unordered-list', style: 'unordered-list-item' }, { icon: 'a-ordered-list', style: 'ordered-list-item' }, { icon: 'a-quote', style: 'blockquote' }];

var SideToolbarExtras = function SideToolbarExtras(_ref) {
  var editorState = _ref.editorState,
      onToggle = _ref.onToggle;

  var selection = editorState.getSelection();
  var blockType = editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
  var styles = require('./Toolbars.scss');
  return _react2.default.createElement(
    'div',
    { className: styles.toolbar + ' side' },
    _react2.default.createElement(
      'ul',
      { className: styles.toolbarIcons },
      BLOCK_TYPES.map(function (type) {
        return _react2.default.createElement(_ToolbarIcon2.default, {
          key: type.label || type.icon,
          active: type.style === blockType,
          label: type.label,
          icon: type.icon,
          onMouseDown: function onMouseDown() {
            onToggle(type.style);
          }
        });
      })
    )
  );
};

var SideToolbar = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(SideToolbar, _Component);

  function SideToolbar(props) {
    (0, _classCallCheck3.default)(this, SideToolbar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SideToolbar.__proto__ || (0, _getPrototypeOf2.default)(SideToolbar)).call(this, props));

    _this.state = {
      isExpanded: false
    };
    return _this;
  }

  (0, _createClass3.default)(SideToolbar, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./Toolbars.scss');
      var isExpanded = this.state.isExpanded;
      var _props = this.props,
          editorState = _props.editorState,
          onUploadImage = _props.onUploadImage,
          onToggle = _props.onToggle,
          onTexInsert = _props.onTexInsert;

      return _react2.default.createElement(
        'div',
        { style: this.props.style, className: styles.sideToolbar },
        _react2.default.createElement('i', { className: 'a-photo', onMouseDown: function onMouseDown(event) {
            return event.preventDefault();
          }, onClick: onUploadImage }),
        _react2.default.createElement('i', { className: 'a-photo', onMouseDown: function onMouseDown(event) {
            return event.preventDefault();
          }, onClick: onTexInsert }),
        _react2.default.createElement(
          'i',
          { className: 'a-menu',
            onMouseEnter: function onMouseEnter() {
              return _this2.setState({ isExpanded: true });
            },
            onMouseDown: function onMouseDown(event) {
              return event.preventDefault();
            },
            onMouseLeave: function onMouseLeave() {
              return _this2.setState({ isExpanded: false });
            }
          },
          isExpanded ? _react2.default.createElement(SideToolbarExtras, { editorState: editorState, onToggle: onToggle }) : null
        )
      );
    }
  }]);
  return SideToolbar;
}(_react.Component), _class.propTypes = {
  onUploadImage: _react.PropTypes.func,
  editorState: _react.PropTypes.object,
  onToggle: _react.PropTypes.func,
  onTexInsert: _react.PropTypes.func,
  style: _react.PropTypes.object
}, _temp);
exports.default = SideToolbar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/RichEditor/components/SideToolbar.js
// module id = 1202
// module chunks = 0